import React, { useState } from 'react';
import DailySheet from './DailySheet';
import ReceiptsPayments from './ReceiptsPayments';

const TABS = [
  { key: 'daily', label: 'Daily Sheet' },
  { key: 'receipts', label: 'Receipts & Payments' },
];

export default function Home() {
  const [tab, setTab] = useState('daily');

  return (
    <div>
      <div className="sub-tabs">
        {TABS.map(t => (
          <div key={t.key} className={'sub-tab ' + (tab === t.key ? 'active' : '')} onClick={() => setTab(t.key)}>
            {t.label}
          </div>
        ))}
      </div>

      {tab === 'daily' && <DailySheet />}
      {tab === 'receipts' && <ReceiptsPayments />}
    </div>
  );
}
